<template>
  <div class="password">
    <div class="password_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="determine" @click="setForget">忘记密码</div>
    </div>
    <div class="password_bottom">
      <div class="password_login">密码登录</div>
      <!-- @submit="onSubmit" -->
      <van-form class="login_form">
        <van-field
          class="input_tel"
          v-model="phone"
          type="tel"
          clearable
          placeholder="请填写手机号"
          :rules="[{ required: true }]"
        >
        </van-field>
        <van-field
          class="input_pas"
          v-model="password"
          :type="isOpen ? 'text' : 'password'"
          placeholder="请填写密码"
          :rules="[{ required: true }]"
        >
          <img
            class="password_img"
            slot="right-icon"
            :src="
              isOpen
                ? require('@/assets/img/login/l_hide.png')
                : require('@/assets/img/login/l_show.png')
            "
            alt=""
            @click="isOpen = !isOpen"
          />
        </van-field>
        <!-- <van-field class="input_check">
          <template #input>
            <div>
              <VerifyLogin
                ref="verify"
                :width="verifyWidth"
                primaryColor="#4A79F1"
                @success="
                  isVerify = true;
                  isShowVerifyMsg = false;
                "
              />
              <div
                v-if="isShowVerifyMsg"
                style="font-size: 12px; color: #ff0000"
              >
                请拖动滑块进行验证
              </div>
            </div>
          </template>
        </van-field> -->
        <van-field name="checkbox" class="input_check">
          <template #input>
            <van-checkbox v-model="agree" shape="square">
              <template #icon="props">
                <img
                  class="img-icon"
                  :src="
                    props.checked
                      ? require('@/assets/img/login/l_sel.png')
                      : require('@/assets/img/login/l_unsel.png')
                  "
                />
              </template>
              <span style="color: #999999">我已阅读并同意</span
              ><span style="color: #4266f5" @click="$router.push('/apptcp')"
                >《使用协议》</span
              ><span
                style="color: #4266f5"
                @click="$router.push('/mPAgreement')"
                >《隐私政策》</span
              ></van-checkbox
            >
          </template>
        </van-field>
        <div style="margin: 10px 0 20px">
          <van-button
            style="border-radius: 22px"
            round
            block
            type="info"
            native-type="submit"
            class="form_btn"
            @click="onSubmit"
            >登录</van-button
          >
        </div>
        <div class="password" @click="toCodeLogin">验证码登录</div>
      </van-form>
      <TipsDialog
        :showDialog="showDialog"
        @dialogCancel="showDialog = false"
        @dialogConfirm="dialogConfirm"
      >
        <p>
          我已阅读并同意《<span
            style="color: #4266f5"
            @click="$router.push('/apptcp')"
            >使用协议</span
          >》《<span
            style="color: #4266f5"
            @click="$router.push('/mPAgreement')"
            >隐私政策</span
          >》
        </p>
      </TipsDialog>
    </div>
  </div>
</template>

<script>
import VerifyLogin from "./verifyLogin.vue";
import TipsDialog from "@/views/mobileView/components/tipsDialog.vue";
import { Toast } from "vant";
export default {
  name: "password",
  components: {
    TipsDialog,
    // VerifyLogin,
  },
  data() {
    return {
      phone: "",
      password: "",
      isOpen: false,
      agree: false,
      showDialog: false,
      verifyWidth: 400,
      isVerify: false,
      isShowVerifyMsg: false,
    };
  },
  mounted() {
    this.verifyWidth =
      document.getElementsByClassName("van-field__control")[0].clientWidth;
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    setForget() {
      this.$router.push("forget");
    },
    toCodeLogin() {
      this.$router.replace("/logins");
    },
    // handleCheckVerify() {
    //   if (!this.password || !this.phone) {
    //     this.isVerify = false;
    //     this.$refs.verify.resetStatus();
    //   }
    //   if (!this.isVerify) {
    //     return (this.isShowVerifyMsg = true);
    //   } else {
    //     this.isShowVerifyMsg = false;
    //   }
    // },
    // 登录提交表单
    async onSubmit() {
      // this.handleCheckVerify();
      // if (this.isShowVerifyMsg) return;
      if (this.agree) {
        const telRegExp = new RegExp("^1[35789]\\d{9}$");
        const pasRegExp = new RegExp(
          "^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$"
        );
        if (!telRegExp.test(this.phone)) {
          Toast("请填写正确的手机号");
          // this.$refs.verify.resetStatus();
        } else if (!pasRegExp.test(this.password)) {
          Toast("请填写6-16位含字母数字密码");
          // this.$refs.verify.resetStatus();
        } else {
          let obj = {
            requestType: "MOBILE",
          };
          obj.username = this.phone;
          obj.password = this.password;
          let res = await this.$apis.loginServe.login(obj);
          if (res.resultCode === "200") {
            Toast("登录成功");
            sessionStorage.setItem("token", res.data.token);
            sessionStorage.setItem("userInfo", JSON.stringify(res.content));
            window.history.go(-1);
          } else {
            // this.$refs.verify.resetStatus();
            Toast(res.resultDesc);
            return;
          }
        }
      } else {
        this.showDialog = true;
      }
    },
    dialogConfirm() {
      this.agree = true;
      this.onSubmit();
    },
  },
};
</script>

<style lang="scss">
html,
body {
  background: #fff;
}

.password {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .password_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;

    .determine {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      position: absolute;
      right: 15px;
    }
  }

  .password_bottom {
    width: 84%;
    overflow: hidden;
    margin: 0 auto;

    .password_login {
      margin-top: 42px;
      font-size: 23px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }

    .login_form {
      margin: 53px -15px 0px -15px;

      .input_tel {
        &::v-deep .van-field__left-icon {
          margin-right: 16px;
          padding: 0 16px 0 7px;
          border-right: 1px solid #dddddd;

          .tel_code {
            font-size: 16px;
            color: #536dfe;
          }

          .fontColor {
            color: #999;
          }
        }

        .van-field__control {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }
      }

      .input_pas {
        &::v-deep .van-field__left-icon {
          margin-right: 16px;
          padding: 0 16px 0 7px;
          border-right: 1px solid #dddddd;
        }

        .password_img {
          width: 15px;
          height: 12px;
        }

        .van-field__control {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }
      }

      .input_check {
        margin-top: 5px;
        background-color: unset;

        &::after {
          content: none !important;
        }

        .img-icon {
          width: 13px;
          height: 13px;
        }
      }

      .form_btn {
        width: 91%;
        height: 44px;
        background: #4a79f1;
        border-radius: 22px !important;
        margin: 0 auto;

        .van-button__text {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
        }
      }

      .password {
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
</style>
